export enum ECampaignMessageType {
  SIMPLE = "SIMPLE",
  CHECK = "CHECK",
}

export enum ECampaignMessageCategory {
  WARNING = "WARNING",
  INFO = "INFO",
}
